module.exports = __webpack_public_path__ + "img/2022年宿迁慈善奖.fdc5fda7.jpg";